import { DropDownList } from "@progress/kendo-react-dropdowns";
import { MDBCol, MDBRow } from "mdbreact";
import React, { useEffect, useState } from "react";
import { getDdSCACData } from "./CarrierMasterPageService";
import "./CarrierMasterSearch.scss";
import { Button } from "@progress/kendo-react-buttons";
import { filterBy } from "@progress/kendo-data-query";

function CarrierMasterSearch({onSearchClickCM}) {
  const [scacData, setScacData] = useState(null);
  const [filteredScacData, setFilteredScacData] = useState(null);
  const [scacValue, setScacValue] = useState({
    value: "all",
    text: "ALL",
  });

  useEffect(() => {
    let isCancelled = false;
    const getDdData = async () => {
      if (!isCancelled) {
        let tempScacData = await getDdSCACData();
        setScacData(tempScacData);
        setFilteredScacData(tempScacData.slice());
      }
    };
    getDdData();
    return () => {
      isCancelled = true;
    };
  }, []);

  function filterChange(event) {
    setFilteredScacData(filterData(event.filter));
  }

  function filterData(filter) {
    const data = scacData.slice();
    return filterBy(data, filter);
  }

  function onScacValueChange(event) {
    setScacValue(event.target.value);
  }

  return (
    <>
      {filteredScacData && (
        <>
          <div className="carrier-master-page-search-card">
            <label><b>SCAC</b></label>
            <DropDownList
              style={{width:"250px"}}
              data={filteredScacData}
              textField="text"
              filterable={true}
              onFilterChange={filterChange}
              onChange={onScacValueChange}
              value={scacValue}
            />
            <Button primary={true} className="searchButton" onClick={() => {onSearchClickCM(scacValue)}}>
              Search
            </Button>
          </div>
          {/* <div>
            <pre>{JSON.stringify(scacData, null, 2)}</pre>
          </div> */}
        </>
      )}
    </>
  );
}

export default CarrierMasterSearch;
